module.exports = __webpack_public_path__ + "img/funding-helps.98759260.png";